import * as React from "react";
import type { SVGProps } from "react";
const SvgAssetsMoreIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="assets_more_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M512 853.333c-188.672 0-341.333-152.661-341.333-341.333 0-188.672 152.661-341.333 341.333-341.333 188.672 0 341.333 152.661 341.333 341.333 0 188.672-152.661 341.333-341.333 341.333zm0 85.334c235.776 0 426.667-190.891 426.667-426.667S747.776 85.333 512 85.333 85.333 276.224 85.333 512 276.224 938.667 512 938.667zm0-469.334a42.667 42.667 0 1 0 0 85.334 42.667 42.667 0 0 0 0-85.334zm-170.667 0a42.667 42.667 0 1 0 0 85.334 42.667 42.667 0 0 0 0-85.334zm341.334 0a42.667 42.667 0 1 0 0 85.334 42.667 42.667 0 0 0 0-85.334z"
    />
  </svg>
);
export default SvgAssetsMoreIcon;
